<script>

import Vue from 'vue/dist/vue.common.js';
import VeeValidate from 'vee-validate';
import EventBus from '../instances/event-bus';
import S3Upload from '../../modules/s3-upload';
import store from '../vuex/store';
import NotesService from '../services/notes';
import Icon from './icon';

Vue.use(VeeValidate);

export default {
  components: {
    Icon
  },
  data () {
    return {
      note: {
        id: null,
        title: null,
        body: null,
        status: "personal",
        noteTypeIds: []
      },
      posting: false,
      attachments: [],
      attachmentTempUrls: [],
      validMimeTypes: [
        'application/msword',
        'application/pdf',
        'application/rtf',
        'application/vnd.ms-excel',
        'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
        'application/vnd.ms-excel.sheet.macroEnabled.12',
        'application/vnd.ms-powerpoint',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
        'application/vnd.ms-word.document.macroEnabled.12',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'text/markdown',
        'text/plain',
        'text/csv',
      ]
    }
  },

  props: {
    noteableId: { required: true },
    noteableType: { required: true },
    noteTypes: "",
  },

  computed: {
    noteTypesArray () {
      return JSON.parse("[" + this.noteTypes + "]");
    },

    loggedIn () {
      return this.$store.state.loggedIn;
    },

    valid () {
      const self = this;
      if ( self.fields.title.valid && self.fields.note.valid && self.fields.attachments.valid ) {
        return true;
      }
      return false;
    },
  },

  mounted() {
    console.log(this.errors.length)
  },

  methods: {
    createNote () {
      const self = this;
      self.posting = true;
      if (self.valid)  {
        NotesService.create(self.noteableId, self.noteableType, self.note, self.attachmentTempUrls).then(
          response => {
            EventBus.$emit('addNote', {node: response.data.createNote, list: self.list});
            EventBus.$emit('closeModal');
            self.posting = false;
          }
        );
      }
    },

    cancel () {
      EventBus.$emit('closeModal');
    },

    uploadTempFiles (event) {
      const self = this;
      self.attachments = event.target.files;
      if (!!self.attachments.length) {
        self.attachmentTempUrls = [];

        for (let i = 0; i < self.attachments.length; i++) {
          new S3Upload(self.attachments[i]).then(
            response => {
              self.attachmentTempUrls.push(response);
            }
          );
        }
      }
    }
  }
}
</script>

<template lang="html">
  <form class="u-form u-form--light" @submit.prevent="createNote">
    <div class="u-mb2">
      <label for="new-note-title">
        Title*
        <span data-error v-show="errors.has('title')">{{ errors.first('title')}}</span>
      </label>
      <input ref="title" id="new-note-title" name="title" type="text" placeholder="Provide a title for the note" v-model="note.title" v-validate="{ required: true }" required>
    </div>

    <div class="u-mb2">
      <label for="new-note-body">
        Note*
        <span data-error v-show="errors.has('note')">{{ errors.first('note')}}</span>
      </label>
      <textarea id="new-note-body" name="note" placeholder="Provide content for the note" v-model="note.body" v-validate="{ required: true }" rows="4" required />
    </div>

    <div class="u-mb2">
      <label for="new-note-attachments">
        Attachments
        <span data-error v-show="errors.has('attachments')">{{ errors.first('attachments')}}</span>
      </label>
      <input type="file"
        id="new-note-attachments"
        name="attachments"
        multiple="true"
        class="u-hide"
        ref="fileInput"
        @change="uploadTempFiles"
        v-validate="{ mimes: validMimeTypes }" />
      <p class="u-form-hint u-mb1">Upload up to 3 files with the following file types: PDF, CSV, Excel, Word, TXT</p>
      <button class="Button Button--outline" @click="$refs.fileInput.click()" type="button">
        Attach Files
      </button>
    </div>

    <ul class="u-mb2" v-if="!!attachments.length">
      <li v-for="(attachment, index) in attachments">
        {{ attachment.name }}
      </li>
    </ul>

    <fieldset class="u-mt4 u-mb4">
      <legend>Tags</legend>
      <div v-for="(noteType, index) in noteTypesArray" class="u-mb1">
        <input v-bind:id="'note-type-' + noteType.id" type="checkbox" :value="noteType.id" v-model="note.noteTypeIds">
        <label v-bind:for="'note-type-' + noteType.id">{{ noteType.name }}</label>
      </div>
    </fieldset>

    <div class="u-mb4">
      <label for="new-note-status">Note Type</label>
      <div class="js-custom-select u-form-veryShortWrapper">
        <select id="new-note-status" v-model="note.status">
          <option value="personal">Personal</option>
          <option value="pending">Public</option>
        </select>
        <icon icon="arrow-down"></icon>
      </div>
    </div>

    <div class="u-form-actions">
      <button v-bind:disabled="posting" type="submit" class="Button Button--square">Create Note</button>
      <button @click="cancel" type="button" class="Button Button--outline">Cancel</button>
    </div>
  </form>
</template>



// WEBPACK FOOTER //
// note-form.vue?23eb66cd